import React, { Component } from "react";
import { connect } from "react-redux";
import { Layer, Group, Rect, RegularPolygon } from "react-konva";
import Konva from "konva";
import PipeUpperRowComponent from './pipe-upper-row-component';
import PipeBottomRowComponent from './pipe-bottom-row-component';
import { getScaledValue } from "../../../actions/calculations-actions";
import PipeRowComponent from './pipe-row-component';
import { InchUtility } from "../../../lib/pipe-dataset";
import {
  setPipeBedPosition,
  setPipeTransformation,
  rotatePipeBed
} from "../../../actions/pipe-bed-actions";


class PipeBedComponent extends Component {
  state = {
    tfmr: null,
    width: this.props.bedWidth,
    length: this.props.bedLength
  }

  /**
   * This method receives the previous properties object and an Array of
   * the properties to be determined if have changed and returns true if any
   * have changed, or false if all are the same.
   * @param {Object} prevProps The previous properties of the component.
   * @param {Array<string>} propNames The Properties names array.
   */
  anyPropHasChanged(prevProps, propNames) {
    let changed = false;
    for (let name of propNames) {
      changed = this.props[name] !== prevProps[name] || changed;
      if (false && this.props[name] !== prevProps[name]) {
        console.log(
          name,
          "changed from",
          prevProps[name],
          "to",
          this.props[name]
        );
      }
    }
    return changed;
  }

  handleOnMouseEnter = () => {
    if (!this.props.isPanning) {
      this.frontArrowNode.getStage().container().style.cursor = "move";
    }
  };
  handleOnMouseLeave = () => {
    if (!this.props.isPanning) {
      this.frontArrowNode.getStage().container().style.cursor = "default";
    }
  };
  handleFrontDragMove = () => {
    let x = this.frontGroupNode.x();
    let y = this.frontGroupNode.y();
    [this.perimeterNode, this.transformNode].forEach((n) => {
      n.x(x);
      n.y(y);
    });
  };
  handleFrontDragEnd = () => {
    /* when drag ends, set position into state */
    this.props.setPipeBedPosition({
      x: this.frontGroupNode.x(),
      y: this.frontGroupNode.y()
    });
    this.frontGroupNode.getLayer().batchDraw();
  };
  mountOrUnmountTransformer = () => {
    /* destroy if transformers exist */
    if (this.state.tfmr) {
      this.state.tfmr.destroy();
      this.setState({ tfmr: null });
    } else {
      this.mountTransformer();
    }
  }
  mountTransformer = () => {
    /* get layer references */
    let layer = this.transformNode.getLayer();
    /* create transformer */
    let tfmr = new Konva.Transformer({
      node: this.transformNode,
      keepRatio: true,
      rotateAnchorOffset: this.props.getScaledValue(10),
      borderStroke: "orange",
      enabledAnchors: ['middle-left', 'top-center', 'bottom-center', 'middle-right']
    });
    layer.add(tfmr);
    layer.batchDraw();
    /* set transformer state */
    this.setState({ tfmr: tfmr });
  };
  handleOnTransform = () => {
    this.handleOnTransformEnd(false);
  };
  handleOnTransformEnd = (submitAction) => {
    /* get layer references */
    let layer = this.transformNode.getLayer();
    let rotation = this.transformNode.rotation() - 90;
    let x = this.transformNode.x();
    let y = this.transformNode.y();
    let width = this.transformNode.height() * this.transformNode.scaleY();
    let length = this.transformNode.width() * this.transformNode.scaleX();

    let wasRotated = this.frontGroupNode.rotation() !== rotation;
    let changedX = this.frontGroupNode.x() !== x;
    let changedY = this.frontGroupNode.x() !== x;
    let changedWidth = this.transformNode.height() !== width;
    let changedHeight = this.transformNode.width() !== length;

    this.frontGroupNode.rotation(rotation);
    this.frontGroupNode.x(x);
    this.frontGroupNode.y(y);
    this.perimeterNode.rotation(rotation);
    this.perimeterNode.x(x);
    this.perimeterNode.y(y);
    layer.batchDraw();

    if (wasRotated) {
      return this.props.rotatePipeBed(
        rotation,
        x,
        y
      );
    }

    if (!(wasRotated || changedX || changedY || changedWidth || changedHeight)) {
      return;
    }

    if (submitAction) {
      this.props.setPipeTransformation(
        rotation,
        x,
        y,
        changedHeight ? length : null,
        changedWidth ? width : null
      );
      this.transformNode.scaleY(1);
      this.transformNode.scaleX(1);
    }
  };

  renderPipeRows = () => {
    const rowLength = ((this.props.bedLength - (this.props.manifoldRowHeight * 2)) - (2 * this.props.perimeterOffset.px));
    const pipeRows = [...new Array(parseInt(this.props.numberOfPipeRows, 10))].map((x, i) => {
      return <PipeRowComponent key={i} index={i} length={rowLength} x={(i * (this.props.rowSpacing.px))} y={this.props.manifoldRowHeight} />
    });
    return pipeRows;
  };

  render() {

    const triangleOffset = this.props.getScaledValue(-3);
    const triangleRadius = this.props.getScaledValue(3);
    const triangleStrokeWidth = this.props.getScaledValue(0.4);

    return (
      <Layer>
        <Group
          //id="pipeBed"
          name="pipeBed"
          x={this.props.x}
          y={this.props.y}
          draggable={true}
          width={this.props.bedWidth}
          height={this.props.bedLength}
          rotation={this.props.rotation}
          onDragEnd={this.handleFrontDragEnd}
          onDragMove={this.handleFrontDragMove}
          onClick={this.mountOrUnmountTransformer}
          ref={node => {
            this.frontGroupNode = node
          }}
        >
          <RegularPolygon
            sides={3}
            opacity={0.7}
            fill={"#0C92CD"}
            stroke={"black"}
            y={triangleOffset}
            radius={triangleRadius}
            x={(this.props.bedWidth) / 2}
            strokeWidth={triangleStrokeWidth}
            onMouseEnter={this.handleOnMouseEnter}
            onMouseLeave={this.handleOnMouseLeave}
            ref={node => {
              this.frontArrowNode = node
            }}
          />
        </Group>
        <Group
          //id="transformPipeGroup"
          name="transformPipeGroup"
          x={this.props.x}
          y={this.props.y}
          onTransform={this.handleOnTransform}
          onTransformEnd={() => {
            this.handleOnTransformEnd(true)
          }}
          rotation={this.props.rotation + 90}
          width={this.props.bedLength}
          height={this.props.bedWidth}
          ref={node => {
            this.transformNode = node;
          }}
        >
          <Rect
            y={-this.props.bedWidth}
            width={this.props.bedLength}
            height={this.props.bedWidth}
          >
          </Rect>
        </Group>
        <Group
          x={this.props.x}
          y={this.props.y}
          rotation={this.props.rotation}
          ref={g => (this.perimeterNode = g)}
        >
          <Rect
            x={0}
            y={0}
            width={this.props.bedWidth}
            height={this.props.bedLength}
            stroke="purple"
            strokeWidth={.5}
            dash={[5, 5]}
            name={'bed'}>
          </Rect>
          <Group
            x={this.props.perimeterOffset.px}
            y={this.props.perimeterOffset.px}
            width={this.props.bedWidth - (this.props.perimeterOffset.px * 2)}
            height={this.props.bedLength - (this.props.perimeterOffset.px * 2)}>
            <PipeUpperRowComponent />
            {this.renderPipeRows()}
            <PipeBottomRowComponent />
          </Group>
        </Group>
      </Layer>
    );
  }
}

const mapStateToProps = state => {
  return {
    x: state.pipeBed.position.x,
    y: state.pipeBed.position.y,
    rotation: state.pipeBed.rotation,
    isPanning: state.viewport.isPanning,
    computeWidth: state.viewport.computeWidth,
    bedWidth: state.pipeBed.dimensions.width.px,
    bedLength: state.pipeBed.dimensions.length.px,
    computedHeight: state.viewport.computedHeight,
    numberOfPipeRows: state.pipeBed.numberOfPipeRows,
    rowSpacing: new InchUtility(state.pipeBed.rowSpacing),
    pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
    perimeterOffset: new InchUtility(state.pipeGlobals.pipePerimeterOffset),
    manifoldRowHeight: state.pipeGlobals.pipeNominalDiameter.horizontalRowHeight.px,
  };
};

const mapDispatchToProps = {
  rotatePipeBed,
  getScaledValue,
  setPipeBedPosition,
  setPipeTransformation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PipeBedComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/pipe-bed-component.js